<template>
   <v-container fluid>
       <div class="text-h4 mb-5 mt-5">Registro Componentes</div>
            <v-card :loading="loadingComponente">
                <v-card-title>
                    <v-text-field
                        v-model="buscarComponente"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                    :headers="headersComponentes"
                    :items="componentes"
                    :search="buscarComponente"
                >
                    <template v-slot:item.created_at="{ item }">
                        {{ formatDate(new Date(item.created_at).toISOString().substr(0, 10)) }}
                    </template>
                </v-data-table>
            </v-card>
            <v-speed-dial
            fixed
            direction="top"
            style="bottom: 37px; right: 30px;"
            >
                <template v-slot:activator>
                    <v-btn
                        color="teal lighten-1"
                        dark
                        fab
                        @click="dialognuevoComponente = true;"
                    >
                    <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </template>
            </v-speed-dial>

            <v-dialog v-model="dialognuevoComponente" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">
                        Nuevo Componente
                    </span>
                    <v-spacer></v-spacer>
                    <v-switch
                        v-model="nuevoComponente.permisoExtendido"
                        label="Permiso extendido"
                    ></v-switch>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="nuevoComponente.nombre"
                                    label="Nombre del componente"
                                    prepend-icon="mdi-package-variant"
                                    required
                                    :error-messages="errorNombre"
                                    @input="$v.nuevoComponente.nombre.$touch()"
                                    @blur="$v.nuevoComponente.nombre.$touch()"
                                    class="anadirAsterisco"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="nuevoComponente.componentePadre_id"
                                    :items="componentes.filter(componente => componente.componente_padre === null)"
                                    prepend-icon="mdi-package-variant"
                                    chips
                                    label="Componente padre"
                                    item-text="nombre"
                                    item-value="id"
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="nuevoComponente.icono"
                                    label="Icono"
                                    prepend-icon="mdi-view-grid-plus-outline"
                                    required
                                    :error-messages="errorIcono"
                                    @input="$v.nuevoComponente.icono.$touch()"
                                    @blur="$v.nuevoComponente.icono.$touch()"
                                    class="anadirAsterisco"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                        text
                        @click="cerrarDialog()"
                    >
                        Cerrar
                    </v-btn>
                    <v-btn 
                        color="blue darken-1" 
                        text
                        @click="añadirComponente()"
                        :disabled="this.$v.$invalid"
                    >
                        Añadir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
   </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import formatDate from '@/mixins/formatearFecha';
import axios from 'axios';
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
    name: 'registroComponentes',
    mixins: [formatDate],
    data: () => ({
        nuevoComponente: {
            nombre: '',
            icono: '',
            permisoExtendido: false,
            componentePadre_id: null
        },
        dialognuevoComponente : false,
        loadingComponente: false,
        buscarComponente: null,
        headersComponentes: [
            {
                text: 'Nombre',
                align: 'start',
                filterable: true,
                sortable: true,
                value: 'nombre',
                width: "70%"
            },
            {
                text: 'Padre',
                filterable: true,
                sortable: true,
                value: 'componente_padre.nombre',
            },
            {
                text: 'Fecha de creación',
                align: 'start',
                filterable: true,
                sortable: true,
                value: 'created_at',
            }
        ],
        componentes: [],
    }),
    mounted(){
        this.getComponentes()
    },
    methods: {
        ...mapActions(['setSnackbar', 'setLoading']),
        async getComponentes(){
            this.loadingComponente = true;
            try {
                let respuesta = await axios.get("/api/componentes");
                this.componentes = respuesta.data;
                console.log(this.componentes);
            } catch (error) {
                console.log(error);
            }
            this.loadingComponente = false;
        },
        async añadirComponente(){
            this.setLoading(true);
            try {
                this.nuevoComponente.permisoExtendido = this.nuevoComponente.permisoExtendido ? 1 : 0;
                await axios.post("api/componentes/crear", this.nuevoComponente);
            } catch (error) {
                this.setSnackbar({
                    tipo: "error",
                    mensaje:
                    "Error. No se ha podido añadir el componente",
                });
            }
            this.cerrarDialog();
            this.setLoading(false);
            this.getComponentes();
        },
        cerrarDialog(){
            this.dialognuevoComponente = false;
            this.$v.$reset(); 
            this.nuevoComponente = {
                nombre: '',
                icono: '',
                permisoExtendido: false,
                componentePadre_id: null
            }
        }
		
    },
    computed: {
        ...mapState('login', ['authUser']),
        errorNombre () {
            if (this.$v.nuevoComponente.nombre.$dirty){
                if (this.$v.nuevoComponente.nombre.$invalid){
                    return 'Introduce el nombre del componente';
                }
            }
        },
        errorIcono () {
            if (this.$v.nuevoComponente.icono.$dirty){
                if (this.$v.nuevoComponente.icono.$invalid){
                    return 'Introduce el icono del componente';
                }
            }
        }
    },
    watch: {
        
    },
    validations: {
      nuevoComponente: {
        nombre: { required },
        icono: { required }
      }
    },
}
</script>